<template>
    <div class="v-main__wrap-bg">
        <v-container style="height: 100%">
            <v-row justify="center" align="center">
                <v-col class="py-5">
                    <v-img
                        src="../../public/e-swarlogo@2x.png"
                        width="110"
                        style="margin: auto"
                    ></v-img>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-card outlined width="450" height="320">
                    <div class="d-flex justify-center" style="color: secondary">
                        <v-img 
                            src="https://www.deaninfo.com/d3/designer/taxapp/dist/img/mail.png" 
                            height="90" 
                            width="90"  
                            contain>
                        </v-img>
                    </div>
                    <v-card-title class="justify-center mt-2">
                        <h3 class="login-box-msg">Check your mail</h3>
                    </v-card-title>
                    <v-row no-gutters>  
                        <v-card-text
                            class="text-center"
                            justify="center"
                            align="center" 
                        >
                            A new password has been sent to your email. Please login with new password.</v-card-text>    
                    </v-row>
                </v-card>
            </v-row>
            <br />
            <v-row align="center" class="justify-center" >
                <router-link to="/">
                    <v-btn 
                        class="btn-login"
                        type="submit">
                            LOGIN 
                    </v-btn>
                </router-link>
            </v-row>
        </v-container>
        <div class="strip-outer">
            <div class="strip-bottom"></div>
        </div>
    </div>
</template>

<script>

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/admin/dashboard");
                }
            }, 0);
        });
    },

    data() {
        return {
            disabled: true,   
        };
    },

    methods: {
    },

    watch: {
        valid(val) {
            if (val) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
    }
};
</script>
<style scoped>
.b-tile >>> .v-input__slot {
    min-height: 40px;
    background: #e8f0fe;
}
.b-tile >>> .v-label {
    top: 10px;
    font-weight: 500;
    font-size: 14px;
}
.b-tile >>> .v-input__append-inner {
    margin-top: 8px;
}
.b-tile >>> .v-icon.v-icon {
    color: #1b73ba61;
}
.v-card {
    box-shadow: 0px 13px 39px #1b73ba21;
    border-radius: 10px;
    padding: 45px;
}
.btn-login{
    border-radius: 0;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border-width: 1px;
    width: 50%;
    font-weight:normal;
    display: block;
    margin: auto;
        background: #3c8dbc!important;
    border-color: #367fa900;
    border: 1px solid transparent;
    color:#fff;
    min-width:242px!important;
    text-decoration:none;
}
a{
    text-decoration: none;
}
</style>